/**
 * Page-retailers template ESM (Phase 10).
 *
 * Replaces theme/js/templates/page-retailers.js. Two behaviors:
 *
 *   1. Country select change (#select-retailers_lists):
 *      cross-fade + slide between two .js-retailers-list[data-country] panels,
 *      flipping their data-active flags once the new panel finishes fading in.
 *      Timing matches the original: fadeOut + slideUp on the current panel
 *      run in a chain; slideDown + fadeIn on the target start `fadeMs + 5ms`
 *      later so the two halves overlap by one duration. Don't smooth this
 *      out without verifying — the visual cadence is intentional.
 *
 *   2. Flagship button hover (.js-flagship-button[data-target-image]):
 *      toggles `.active` on the matching .js-flagship-image[data-image].
 *
 * Source path: theme/js/templates/page-retailers.esm.js
 * Built name : ./page-retailers.js
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Opus 4.7
 *
 * [PageRetailers]
 */

import { log } from './log.js';
import { fade, slideDown, slideUp } from './core-anim.js';
import { getEasing } from './easing.js';

const SELECT_ID = 'select-retailers_lists';
const LIST_SELECTOR = '.js-retailers-list';
const FLAGSHIP_BUTTON_SELECTOR = '.js-flagship-button';
const FLAGSHIP_IMAGE_SELECTOR = '.js-flagship-image';
const FADE_MS = 600;
const SLIDE_MS = 600;

function handleSelectChange(event) {
  const select = event.target;
  if (!select || select.id !== SELECT_ID) return;
  const value = select.value;
  const target = document.querySelector(`${LIST_SELECTOR}[data-country="${value}"]`);
  const current = document.querySelector(`${LIST_SELECTOR}[data-active="true"]`);
  if (!target || !current || target === current) return;

  const easing = getEasing();
  fade(current, { from: 1, to: 0, duration: FADE_MS, easing }).then(() =>
    slideUp(current, { duration: SLIDE_MS, easing })
  );
  setTimeout(() => {
    slideDown(target, { duration: SLIDE_MS, easing }).then(() =>
      fade(target, { from: 0, to: 1, duration: FADE_MS, easing }).then(() => {
        current.setAttribute('data-active', 'false');
        target.setAttribute('data-active', 'true');
      })
    );
  }, FADE_MS + 5);
}

function handleFlagshipHover(event) {
  const button = event.target.closest && event.target.closest(FLAGSHIP_BUTTON_SELECTOR);
  if (!button) return;
  const targetImage = button.getAttribute('data-target-image');
  if (!targetImage) return;
  const image = document.querySelector(`${FLAGSHIP_IMAGE_SELECTOR}[data-image="${targetImage}"]`);
  if (!image) return;
  image.classList.toggle('active', event.type === 'mouseenter');
}

document.addEventListener('change', handleSelectChange);
document.addEventListener('mouseenter', handleFlagshipHover, true);
document.addEventListener('mouseleave', handleFlagshipHover, true);

log('[PageRetailers] registered');
